// stores/projects.ts
import { ICryptoProject } from 'types/cryptoProject';
import { create } from 'zustand';

interface IProjectsStore {
  projects: ICryptoProject[];
  total: number;
  page: number;
  pageSize: number;
  isLoading: boolean;
  searchQuery: string;
  isHidden: boolean;
  projectToEdit: ICryptoProject | null;
  isProjectOnEdit: boolean;
  
  setIsProjectOnEdit: (isProjectOnEdit: boolean) => void;
  setProjectToEdit: (project: ICryptoProject | null) => void;
  setProjects: (projects: ICryptoProject[]) => void;
  setTotal: (total: number) => void;
  setLoading: (isLoading: boolean) => void;
  setPage: (page: number) => void;
  setSearchQuery: (query: string) => void;
  setIsHidden: (isHidden: boolean) => void;
  setPageSize: (pageSize: number) => void;
}

export const projectsStore = create<IProjectsStore>((set) => ({
  projects: [],
  total: 0,
  page: 1,
  pageSize: 10,
  isLoading: false,
  searchQuery: '',
  isHidden: false,
  projectToEdit: null,
  isProjectOnEdit: false,
  
  setIsProjectOnEdit: (isProjectOnEdit) => set({ isProjectOnEdit }),
  setProjectToEdit: (project) => set({ projectToEdit: project }),
  setProjects: (projects) => set({ projects }),
  setTotal: (total) => set({ total }),
  setLoading: (isLoading) => set({ isLoading }),
  setPage: (page) => set({ page }),
  setSearchQuery: (query) => set({ searchQuery: query }),
  setIsHidden: (isHidden) => set({ isHidden }),
  setPageSize: (pageSize) => set({ pageSize }),
}));

export const useProjectsStore = projectsStore;
